// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const useStyles = () => ({
  button: {
    padding: '6px',
  },
  popover: {
    pointerEvents: 'none',
  },
  popoverText: {
    width: '240px',
    padding: '8px 22px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '3px',
  },
  popoverTextLine: {
    fontSize: '13px',
  },
  checkIcon: {
    fontSize: '12px',
    color: '#ffffff',
    fontWeight: 600,
  },
  badge: {
    '& .MuiBadge-badge': {
      height: '20px',
      width: 0,
      backgroundColor: '#6DD400',
      borderRadius: '50%',
      top: '5%',
      right: '45%',
      position: 'relative',
    },
  },
  circularProgress: {
    'svg circle': {
      stroke: 'url(#my_gradient)',
    },
    position: 'absolute',
    top: 0,
    right: '19px',
    width: '30px !important',
    height: '30px !important',
  },
});

export default useStyles;
